module.exports = __webpack_public_path__ + "7fe2e220d11e2288301ddaf50ea43fd5.png";